import { Component, ElementRef, ViewChild } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-popin',
    templateUrl: './popin-shared.component.html',
    styleUrls: ['./popin-shared.component.scss'],
    standalone: true,
    imports: [TranslateModule, SvgIconComponent],
})
export class PopinSharedComponent {

    @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;
    @ViewChild('firstButton') firstButton!: ElementRef<HTMLButtonElement>;

    messagePopIn = '';
    messageButton = '';
    titre: string | null = null;

    private opener: HTMLElement | null = null;
    private _resolver!: (value: boolean) => void;

    result: Promise<boolean> = new Promise(resolve => this._resolver = resolve);

    open(message: string, button: string, title: string | null) {
        this.messagePopIn = message;
        this.messageButton = button;
        this.titre = title;

        this.opener = document.activeElement as HTMLElement;

        const dlg = this.dialog.nativeElement;
        dlg.showModal();

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    close(value: boolean) {
        const dlg = this.dialog.nativeElement;
        dlg.close();

        this.opener?.focus();
        this._resolver(value);

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

    onCancel(event: Event) {
        event.preventDefault();
        this.close(false);
    }
}
